{
  "DECK_SELECTOR_TITLE": "Mes Decks",
  "MAP_SELECT_TITLE": "Choisir une Carte",
  "DECKBUILDER_TAB_TOWERS": "TOURS",
  "DECKBUILDER_TAB_UNITS": "UNITÉS",
  "DECKBUILDER_TAB_HERO": "HÉROS",
  "HUD_CLOSE": "Fermer",
  "HUD_SURRENDER": "Abandonner",
  "HUD_SURRENDER_CONFIRM": "Vraiment abandonner ?",
  "HUD_WAVE": "Vague",
  "HUD_DAILY_QUESTS": "QUÊTES QUOTIDIENNES",
  "HUD_NO_ACTIVE_QUESTS": "Aucune quête active",
  "HUD_SPELL_READY": "Prêt",
  "HUD_SPY_LABEL": "SPY",
  "HUD_UPGRADE": "Améliorer",
  "HUD_MAX_LEVEL": "NIVEAU MAX",
  "HUD_DEMOLISH": "Démolir (50% remboursé)",
  "HUD_CHOOSE_PATH": "Choisir un chemin (irréversible) :",
  "HUD_MUSIC_ON": "Activer la musique",
  "HUD_MUSIC_OFF": "Désactiver la musique",
  "MATCH_RESULT_NO_STATS": "Aucune statistique disponible",
  "MATCH_RESULT_VICTORY": "VICTOIRE",
  "MATCH_RESULT_DEFEAT": "DÉFAITE",
  "MATCH_RESULT_DRAW": "MATCH NUL",
  "MATCH_RESULT_WINNER": "Gagnant :",
  "MATCH_RESULT_TOTAL_DAMAGE": "Dégâts totaux :",
  "MATCH_RESULT_GOLD_EARNED": "Or gagné :",
  "MATCH_RESULT_UNITS_SENT": "Unités envoyées :",
  "MATCH_RESULT_TOWERS_BUILT": "Tours construites :",
  "MATCH_RESULT_DURATION": "Durée du match :",
  "MATCH_RESULT_PLAY_AGAIN": "Rejouer",
  "MATCH_RESULT_MAIN_MENU": "Menu principal",
  "SHOP_TITLE": "Boutique",
  "SHOP_GOLD_LABEL": "Or :",
  "SHOP_GEMS_COMING_SOON": "Les achats de gemmes seront disponibles dans la prochaine version.",
  "SHOP_SEASON_COMING_SOON": "S'abonner — Bientôt disponible",
  "SHOP_TAB_PACKS": "Packs",
  "SHOP_TAB_GEMS": "Gemmes",
  "SHOP_TAB_SEASON": "Pass Saison",
  "SHOP_BUY": "Acheter",
  "SHOP_NOT_ENOUGH_GOLD": "Pas assez d'or",
  "SHOP_GEMS_LABEL": "Gemmes",
  "SHOP_COMING_SOON_BADGE": "Bientôt disponible",
  "SHOP_SUBSCRIBE": "S'abonner — Bientôt disponible",
  "SHOP_DURATION_DAYS": "Durée :",
  "QUEST_WIDGET_TITLE": "Quêtes actives",
  "QUEST_WIDGET_ALL_LINK": "Toutes les quêtes →",
  "MAIN_MENU_TITLE": "Ultimaze Tower Wars",
  "MAIN_MENU_PLAY_PVP": "⚔ PvP — Jouer maintenant",
  "MAIN_MENU_PLAY": "Jouer contre Bot",
  "MAIN_MENU_DECK_BUILDER": "🃏 Constructeur de deck",
  "MAIN_MENU_MY_DECKS": "📂 Mes Decks",
  "MAIN_MENU_SHOP": "🛒 Boutique",
  "MAIN_MENU_INVENTORY": "🎒 Inventaire",
  "MAIN_MENU_PROFILE": "📊 PROFIL",
  "MAIN_MENU_SETTINGS": "⚙ Paramètres",
  "MAIN_MENU_LOGIN_REGISTER": "Connexion / Inscription",
  "MAIN_MENU_LOGOUT": "Déconnexion",
  "INVENTORY_TITLE": "Inventaire",
  "INVENTORY_BACK": "← Retour",
  "INVENTORY_EMPTY": "Aucun pack non ouvert",
  "INVENTORY_EMPTY_SHOP_LINK": "→ Aller à la boutique",
  "INVENTORY_OPEN_BTN": "Ouvrir",
  "INVENTORY_PACKS_SECTION": "Packs non ouverts",
  "SETTINGS_TITLE": "Paramètres",
  "SETTINGS_LANGUAGE": "Langue",
  "SETTINGS_BACK": "← Retour",
  "SETTINGS_SOUND": "Son",
  "LOGIN_TITLE": "Se connecter",
  "LOGIN_EMAIL": "E-Mail",
  "LOGIN_PASSWORD": "Mot de passe",
  "LOGIN_SUBMIT": "Se connecter",
  "LOGIN_REGISTER_LINK": "Pas encore de compte ? S'inscrire →",
  "LOGIN_GUEST": "Jouer en tant qu'invité →",
  "LOGIN_FORGOT_PASSWORD": "Mot de passe oublié ?",
  "LOGIN_RESET_SEND": "Envoyer le lien de réinitialisation",
  "LOGIN_RESET_SENT": "Si cet e-mail est enregistré, un lien de réinitialisation a été envoyé.",
  "LOGIN_BACK_TO_LOGIN": "← Retour à la connexion",
  "REGISTER_TITLE": "S'inscrire",
  "REGISTER_DISPLAYNAME": "Nom d'affichage",
  "REGISTER_SUBMIT": "S'inscrire",
  "REGISTER_LOGIN_LINK": "Déjà inscrit ? Se connecter →",
  "REGISTER_CONFIRM_PASSWORD": "Confirmer le mot de passe",
  "REGISTER_PASSWORD_TOO_SHORT": "Le mot de passe doit contenir au moins 8 caractères.",
  "REGISTER_PASSWORDS_MISMATCH": "Les mots de passe ne correspondent pas.",
  "LEADERBOARD_TITLE": "🏆 Classement",
  "LEADERBOARD_GLOBAL": "Mondial",
  "LEADERBOARD_NATIONAL": "National",
  "LEADERBOARD_LOADING": "Chargement des données...",
  "LEADERBOARD_BACK": "← Retour",
  "LEADERBOARD_MY_POSITION": "Votre position :",
  "LEADERBOARD_TOTAL_PLAYERS": "{{count}} joueurs au total",
  "LEADERBOARD_MONTH_LABEL": "Sélectionner le mois",
  "LEADERBOARD_EMPTY": "Aucune entrée trouvée.",
  "AUTH_ERROR_INVALID_CREDENTIALS": "E-Mail ou mot de passe incorrect.",
  "AUTH_ERROR_EMAIL_TAKEN": "Cette adresse e-mail est déjà utilisée.",
  "AUTH_ERROR_NETWORK": "Erreur réseau. Veuillez réessayer.",
  "PROGRESSION_TITLE": "Profil du joueur",
  "PROGRESSION_BACK": "← Retour",
  "PROGRESSION_EXPERIENCE": "Expérience",
  "PROGRESSION_CURRENCY": "Monnaie",
  "PROGRESSION_GOLD": "Or",
  "PROGRESSION_GEMS": "Gemmes",
  "PROGRESSION_PACK_PROGRESS": "Progression des packs",
  "PROGRESSION_OPEN_PACK": "🎁 Ouvrir un pack !",
  "PROGRESSION_DAILY_QUESTS": "Quêtes quotidiennes",
  "PROGRESSION_WEEKLY_QUESTS": "Quêtes hebdomadaires",
  "PROGRESSION_ACHIEVEMENT_QUESTS": "Quêtes de succès",
  "PROGRESSION_ACHIEVEMENTS": "Succès (récemment débloqués)",
  "PROGRESSION_CARD_COLLECTION": "Collection de cartes",
  "PROGRESSION_CARDS_COLLECTED": "{{owned}}/{{total}} cartes collectées",
  "PROGRESSION_DAILY_PACK": "🎁 Pack quotidien",
  "PROGRESSION_FRIENDS": "👥 Amis",
  "PROGRESSION_CLAIM": "Récupérer",
  "DECK_SELECTOR_BACK": "← Retour",
  "DECK_SELECTOR_NEW_DECK": "+ Nouveau Deck",
  "DECK_SELECTOR_SELECTED": "(sélectionné)",
  "DECK_SELECTOR_CARDS": "cartes",
  "DECK_SELECTOR_EDIT": "Modifier",
  "DECK_BUILDER_CANCEL": "Annuler",
  "DECK_BUILDER_SAVE": "Enregistrer",
  "DECK_BUILDER_NAME_PLACEHOLDER": "Nom du deck",
  "DECK_BUILDER_TOTAL_COST": "Coût total :",
  "DECK_BUILDER_TOWERS_SECTION": "TOURS",
  "DECK_BUILDER_UNITS_SECTION": "UNITÉS",
  "DECK_BUILDER_HERO_SECTION": "HÉROS",
  "DECK_BUILDER_ELEMENTS": "Éléments",
  "DECK_BUILDER_FILTER_ALL": "Tous",
  "DECK_BUILDER_EMPTY_SLOT": "Vide — appuyer pour ajouter",
  "DECK_BUILDER_NO_TOWERS": "Aucune tour pour cet élément.",
  "DECK_BUILDER_NO_UNITS": "Aucune unité pour cet élément.",
  "DECK_BUILDER_TAB_TOWERS": "Tours",
  "DECK_BUILDER_TAB_UNITS": "Unités",
  "DECK_BUILDER_TAB_HEROES": "Héros",
  "DECK_BUILDER_CHOOSE_TOWER_SLOT": "Choisir une carte pour l'emplacement tour {{slot}} — ou appuyer à nouveau pour fermer",
  "DECK_BUILDER_CHOOSE_UNIT_SLOT": "Choisir une carte pour l'emplacement unité {{slot}}",
  "DECK_BUILDER_CHOOSE_HERO": "Choisir un héros",
  "DECK_BUILDER_ERROR_NAME": "Le nom du deck est requis.",
  "DECK_BUILDER_ERROR_HERO": "Un héros est requis.",
  "DECK_BUILDER_ERROR_TOWERS": "Au moins 1 tour est requise.",
  "MATCHMAKING_TITLE": "RECHERCHE D'ADVERSAIRE",
  "MATCHMAKING_SEARCHING": "Recherche en cours... {{seconds}}s",
  "MATCHMAKING_FOUND": "Adversaire trouvé : {{name}} !",
  "MATCHMAKING_ERROR": "Erreur de connexion",
  "MATCHMAKING_VS_BOT": "Jouer contre un bot",
  "MATCHMAKING_RETRY": "Réessayer",
  "MATCHMAKING_CANCEL": "Annuler",
  "MATCHMAKING_RANK_LABEL": "Votre rang",
  "MATCHMAKING_QUEUE_POSITION": "Position dans la file : {{position}}",
  "MATCHMAKING_RELAXING": "Élargissement de la zone de recherche...",
  "MATCHMAKING_OPPONENT_RANK": "Rang de l'adversaire : {{mmr}}",
  "MATCHMAKING_SERVER_OFFLINE": "Serveur indisponible",
  "MATCHMAKING_SERVER_OFFLINE_DESC": "Pas d'internet ou serveur hors ligne — vous jouez contre un bot",
  "MATCHMAKING_FALLBACK_TITLE": "Aucun adversaire trouvé",
  "MATCHMAKING_FALLBACK_DESC": "Vous jouez maintenant contre un bot",
  "MATCHMAKING_FALLBACK_STARTING": "Match en cours de démarrage...",
  "PACK_OPEN_TITLE": "Ouvrir le pack",
  "PACK_OPEN_CLOSE": "Fermer",
  "PACK_OPEN_NEW": "NOUVEAU",
  "DAILY_PACK_CLAIM": "🎁 Récupérer le pack gratuit !",
  "DAILY_PACK_TOMORROW": "Disponible demain — {{countdown}}",
  "HUD_TOOLTIP_DAMAGE": "Dégâts",
  "HUD_TOOLTIP_SPEED": "Vitesse",
  "HUD_TOOLTIP_RANGE": "Portée",
  "HUD_TOOLTIP_CRIT": "Crit",
  "HUD_TOOLTIP_SLOW": "Ralentissement",
  "HUD_TOOLTIP_CHAIN": "Sauts en chaîne",
  "HUD_TOOLTIP_INCOME": "Revenu",
  "HUD_TOOLTIP_ARMOR": "Armure",
  "HUD_TOOLTIP_DODGE": "Esquive",
  "HUD_TOOLTIP_KILL_REWARD": "Récompense de kill",
  "HUD_QUEST_CLAIMED": "récupéré",
  "HUD_SOUND_OFF": "Son désactivé",
  "HUD_SOUND_ON": "Son activé",
  "HUD_ROTATE_VIEW": "Pivoter la vue (R)",
  "HUD_BUILD": "Construire",
  "HUD_SEND_UNIT": "Envoyer une unité",
  "HUD_SPY_ENEMY": "Observer l'adversaire",
  "HUD_CANCEL_PLACEMENT": "Annuler le placement",
  "HUD_BASE_MAX": "Base MAX",
  "RARITY_COMMON": "Commun",
  "RARITY_RARE": "Rare",
  "RARITY_EPIC": "Épique",
  "RARITY_LEGENDARY": "Légendaire",
  "PHASER_GOLD_UNIT": "Or",
  "PHASER_PACK_TAP_HINT": "Appuyez sur une carte pour la révéler",
  "PHASER_PACK_REVEAL_ALL": "Tout révéler",
  "PHASER_PACK_CLOSE": "Fermer",
  "PHASER_PACK_NEW_BADGE": "NOUVEAU!",

  "MAP_SELECT_BACK": "← Retour",
  "MAP_SELECT_DESC_VULKAN": "Terrain volcanique aux couloirs étroits",
  "MAP_SELECT_DESC_KUESTENFORT": "Forteresse côtière avec traversées d'eau",
  "MAP_SELECT_DESC_RUINEN": "Ruines antiques avec plusieurs itinéraires",
  "MAP_SELECT_DESC_EISOEDE": "Toundra gelée aux blocs de glace cristallins",
  "MAP_SELECT_DESC_WUESTE": "Arène balayée par le sable avec des crêtes de dunes diagonales",
  "MAP_SELECT_DESC_DSCHUNGEL": "Labyrinthe de jungle dense aux sentiers enchevêtrés",
  "MAP_SELECT_DESC_HOCHGEBIRGE": "Champ de bataille alpin avec des affleurements rocheux — Nature et Lumière dominent",
  "MAP_SELECT_DESC_SUMPF": "Marais enveloppé de brume aux sentiers tortueux — Eau et Ombre règnent",

  "HUD_SPELL_COOLDOWN_LABEL": "Recharge",
  "HUD_SPELL_COOLDOWN_REMAINING": "encore {{secs}}s",
  "HUD_SPELL_READY_Q": "Prêt (Q)",

  "HUD_TOOLTIP_SPLASH": "Éclaboussure",
  "HUD_TOOLTIP_RANGE_CELLS": "cellules portée",

  "SETTINGS_ACCOUNT": "Compte",
  "SETTINGS_USERNAME": "Nom d'utilisateur",
  "SETTINGS_EMAIL": "E-Mail",
  "SETTINGS_PASSWORD": "Mot de passe",
  "SETTINGS_CHANGE_PASSWORD": "Changer le mot de passe",
  "SETTINGS_SERVER": "Serveur",
  "SETTINGS_SOCIAL": "Lier les réseaux sociaux",
  "SETTINGS_SOCIAL_CONNECT": "Connecter",
  "SETTINGS_SOCIAL_CONNECTED": "Connecté",
  "SETTINGS_SOCIAL_DISCONNECT": "Déconnecter",
  "SETTINGS_PAYMENT": "Méthodes de paiement",
  "SETTINGS_PAYMENT_ADD": "Ajouter",
  "SETTINGS_PAYMENT_CONNECTED": "Lié",
  "SETTINGS_PAYMENT_REMOVE": "Supprimer",
  "SETTINGS_CURRENT_PASSWORD": "Mot de passe actuel",
  "SETTINGS_SAVE": "Enregistrer",
  "SETTINGS_SAVING": "Enregistrement...",
  "SETTINGS_SAVED": "Enregistré ✓",
  "SETTINGS_SAVE_ERROR": "Échec de l'enregistrement — veuillez réessayer",
  "SETTINGS_GUEST_NOTE": "Non connecté — la langue est sauvegardée localement",
  "TUTORIAL_STEP_1_TITLE": "Bienvenue dans Ultimaze Tower Wars !",
  "TUTORIAL_STEP_1_DESC": "Construisez un labyrinthe de tours, envoyez des unités contre votre adversaire et détruisez sa base — avant qu'il détruise la vôtre !",
  "TUTORIAL_STEP_2_TITLE": "Construire des tours",
  "TUTORIAL_STEP_2_DESC": "Appuyez sur une cellule libre et choisissez une tour dans votre main. Les tours tirent automatiquement sur les unités. Important : vous ne pouvez jamais bloquer complètement le chemin !",
  "TUTORIAL_STEP_3_TITLE": "Envoyer des unités",
  "TUTORIAL_STEP_3_DESC": "Envoyez des unités contre votre adversaire ! Chaque unité envoyée augmente définitivement vos revenus. Plus vite elles atteignent la base, plus elles infligent de dégâts.",
  "TUTORIAL_STEP_4_TITLE": "Utiliser les forces élémentaires",
  "TUTORIAL_STEP_4_DESC": "Chaque élément a des forces et des faiblesses. Construisez votre deck autour des synergies élémentaires !",
  "TUTORIAL_STEP_4_ELEMENT_CYCLE": "Feu → Nature → Eau → Feu (×1,8 chacun)\nÉlectro → Eau (×2,0 — contre le plus puissant !)",
  "TUTORIAL_STEP_4_AXIS": "Lumière ↔ Ombre : ×2,0 dans les deux sens — contre absolu !",
  "TUTORIAL_STEP_5_TITLE": "Prêt pour votre premier match !",
  "TUTORIAL_STEP_5_DESC": "Tutoriel terminé ! Votre récompense :",
  "TUTORIAL_NEXT": "Suivant →",
  "TUTORIAL_SKIP": "Passer",
  "TUTORIAL_COMPLETE": "Commencer le match ! 🎮",
  "TUTORIAL_REWARD_TITLE": "Récompense du tutoriel",
  "TUTORIAL_REWARD_XP": "+150 XP",
  "TUTORIAL_REWARD_GOLD": "+200 Or",
  "TUTORIAL_REWARD_PACK": "+1 Pack de démarrage",
  "TUTORIAL_ACHIEVEMENT_UNLOCKED": "🏆 Succès débloqué : Tutoriel terminé !",
  "TOAST_QUEST_COMPLETED": "Quête terminée : {{title}}",
  "TOAST_ACHIEVEMENT_UNLOCKED": "🏆 Succès : {{title}}",
  "TOAST_MATCH_WIN": "Victoire ! +{{xp}} XP gagnés",
  "TOAST_REWARD_CLAIMED": "Récompense reçue : +{{xp}} XP, +{{gold}} Or",
  "TOAST_TUTORIAL_REWARD": "🎁 Récompense du tutoriel reçue ! +150 XP, +200 Or, +1 Pack",
  "FEEDBACK_TITLE": "Retour & Rapport de bug",
  "FEEDBACK_BACK": "Retour",
  "FEEDBACK_TYPE_LABEL": "Type",
  "FEEDBACK_TYPE_BUG": "🪲 Bug",
  "FEEDBACK_TYPE_IDEA": "💡 Idée",
  "FEEDBACK_TYPE_OTHER": "💬 Autre",
  "FEEDBACK_TITLE_LABEL": "Titre",
  "FEEDBACK_TITLE_PLACEHOLDER": "Courte description (120 caractères max)",
  "FEEDBACK_DESC_LABEL": "Description",
  "FEEDBACK_DESC_PLACEHOLDER": "Que s'est-il passé ? Étapes de reproduction, suggestion, etc. (2000 caractères max)",
  "FEEDBACK_SUBMIT": "Envoyer",
  "FEEDBACK_SUBMITTING": "Envoi en cours...",
  "FEEDBACK_SUCCESS_TITLE": "Merci pour votre retour !",
  "FEEDBACK_SUCCESS_DESC": "Nous prenons chaque signalement au sérieux. Conservez votre ID pour vérifier le statut.",
  "FEEDBACK_SUCCESS_ID": "Votre ID de rapport :",
  "FEEDBACK_ERROR": "Échec de l'envoi. Veuillez réessayer.",
  "FEEDBACK_VALIDATION_REQUIRED": "Veuillez remplir tous les champs.",
  "FEEDBACK_MY_REPORTS_TITLE": "Mes rapports",
  "FEEDBACK_STATUS_NEW": "🆕 Reçu",
  "FEEDBACK_STATUS_REVIEWING": "🔍 En cours d'examen",
  "FEEDBACK_STATUS_CONFIRMED": "✅ Confirmé",
  "FEEDBACK_STATUS_RESOLVED": "🔧 Résolu",
  "FEEDBACK_STATUS_REJECTED": "❌ Rejeté",
  "FEEDBACK_ACHIEVEMENT_HINT": "Les rapports confirmés et résolus comptent pour le succès Bug-Tracker !",
  "FEEDBACK_BTN_REPORT": "Retour / Signaler un bug",
  "ERROR_BOUNDARY_HEADING": "Une erreur est survenue",
  "ERROR_BOUNDARY_RELOAD": "Recharger",
  "OFFLINE_BANNER_TEXT": "Pas de connexion Internet — le PvP et les fonctions en ligne ne sont pas disponibles",
  "PUSH_MODAL_TITLE": "Restez dans la partie !",
  "PUSH_MODAL_BODY": "Recevez des rappels quotidiens pour vos packs et des notifications quand des adversaires sont trouvés.",
  "PUSH_MODAL_BULLET_PACK": "✅ Rappels gratuits de packs quotidiens",
  "PUSH_MODAL_BULLET_PVP": "✅ Notifications de matchs PvP",
  "PUSH_MODAL_ACCEPT": "Oui, autoriser les notifications",
  "PUSH_MODAL_SETTING_UP": "Configuration en cours...",
  "PUSH_MODAL_DECLINE": "Pas maintenant",
  "LEADERBOARD_COL_RANK": "#",
  "LEADERBOARD_COL_NAME": "Nom",
  "LEADERBOARD_COL_COUNTRY": "Pays",
  "LEADERBOARD_COL_POINTS": "Points",
  "LEADERBOARD_COL_LEAGUE": "Ligue",
  "SETTINGS_SOCIAL_SHARING_NOTE": "Partagez vos decks, stats de match et résultats du classement directement via vos réseaux sociaux.",
  "SETTINGS_PAYMENT_NOTE": "Nous ne stockons aucune donnée de paiement. Le traitement est effectué exclusivement par le fournisseur concerné (PayPal, Apple Pay, etc.).",
  "MAP_SELECT_SYNERGY": "SYNERGIE",
  "BOT_NAMES": ["Valdris le Sombre", "Sylara la Rapide", "Gorak Brise-Roc", "Mira Cœur-de-Flamme", "Theron le Gardien", "Nyx Tisseur d'Ombres", "Aldric l'Invaincu", "Sora Lame-du-Vent"],
  "MATCHMAKING_ANON_PREFIX": "Joueur",
  "ELEMENT_NAME_FIRE": "Feu",
  "ELEMENT_NAME_WATER": "Eau",
  "ELEMENT_NAME_NATURE": "Nature",
  "ELEMENT_NAME_ELEKTRO": "Électro",
  "ELEMENT_NAME_LIGHT": "Lumière",
  "ELEMENT_NAME_SHADOW": "Ombre",
  "ELEMENT_NAME_NEUTRAL": "Neutre",
  "QUEST_SEND_UNITS_10": "Envoyer 10 unités",
  "QUEST_WIN_MATCH": "Gagner un match",
  "QUEST_BUILD_20_TOWERS": "Construire 20 tours en un tour",
  "QUEST_WIN_5_PVP": "Gagner 5 matchs PvP",
  "QUEST_COMPLETE_TUTORIAL": "Tutoriel terminé",
  "QUEST_BUG_TRACKER_BRONZE": "🪲 Traqueur de bugs Bronze",
  "QUEST_BUG_TRACKER_SILBER": "🪲 Traqueur de bugs Argent",
  "QUEST_BUG_TRACKER_GOLD": "🪲 Traqueur de bugs Or",
  "QUEST_BUG_TRACKER_PLATIN": "🪲 Traqueur de bugs Platine",
  "QUEST_BUG_TRACKER_DIAMANT": "🪲 Traqueur de bugs Diamant",
  "QUEST_SEND_UNITS_10_DESC": "Envoyez 10 unités sur l'adversaire lors d'un même match.",
  "QUEST_WIN_MATCH_DESC": "Gagnez un match contre un adversaire ou un bot.",
  "QUEST_BUILD_20_TOWERS_DESC": "Placez 20 tours sur la grille en un seul tour.",
  "QUEST_WIN_5_PVP_DESC": "Gagnez 5 matchs PvP cette semaine.",
  "BOOT_LOADING_GAMEDATA": "Chargement des données de jeu...",
  "BOOT_LOADING_READY": "Prêt !",
  "FRIENDS_TAB_LIST": "Amis",
  "FRIENDS_TAB_REQUESTS": "Demandes",
  "FRIENDS_TAB_SEARCH": "Rechercher",
  "FRIENDS_LOADING": "Chargement des amis...",
  "FRIENDS_EMPTY": "Pas encore d'amis. Cherchez des joueurs !",
  "FRIENDS_NO_REQUESTS": "Aucune demande en attente.",
  "FRIENDS_CHALLENGE": "Envoyer un défi",
  "FRIENDS_CHALLENGE_SENT": "Défi envoyé ! 60 secondes pour accepter.",
  "FRIENDS_CHALLENGE_OFFLINE": "Ce joueur n'est pas en ligne.",
  "FRIENDS_ACCEPT": "Accepter",
  "FRIENDS_DECLINE": "Refuser",
  "FRIENDS_REQUEST_ACCEPTED": "Demande d'ami acceptée !",
  "FRIENDS_REQUEST_SENT": "Demande envoyée !",
  "FRIENDS_REQUEST_ERROR": "Échec de l'envoi de la demande.",
  "FRIENDS_ADD": "Ajouter",
  "FRIENDS_ALREADY_FRIENDS": "Déjà amis",
  "FRIENDS_PENDING": "Demande en attente",
  "FRIENDS_SEARCH_PLACEHOLDER": "Entrez un nom ou #CODE...",
  "FRIENDS_SEARCHING": "Recherche...",
  "FRIENDS_SEARCH_EMPTY": "Aucun joueur trouvé.",
  "FRIENDS_LOGIN_REQUIRED": "Connectez-vous pour utiliser le système d'amis.",

  "INVENTORY_TAB_PACKS": "Packs",
  "INVENTORY_TAB_CARDS": "Cartes",
  "INVENTORY_CARDS_EMPTY": "Pas encore de cartes. Ouvrez des packs !",
  "INVENTORY_CARD_COPIES": "{{copies}}×",

  "CARD_DETAIL_BACK": "Retour",
  "CARD_DETAIL_NOT_FOUND": "Carte introuvable.",
  "CARD_DETAIL_LEVEL": "Nv. {{level}}",
  "CARD_DETAIL_COPIES_TO_NEXT": "{{have}} / {{needed}} copies pour le prochain niveau",
  "CARD_DETAIL_MAX_LEVEL": "NIVEAU MAX atteint",
  "CARD_DETAIL_LEVEL_BONUSES": "Bonus de niveau",
  "CARD_DETAIL_STATS": "Statistiques",
  "CARD_DETAIL_STATS_BASE": "Base",
  "CARD_DETAIL_STATS_CURRENT": "Actuel",
  "CARD_DETAIL_SKILL_TREE": "Arbre de compétences",
  "CARD_DETAIL_GATE_LEVEL": "Porte Nv. {{level}}",
  "CARD_DETAIL_GATE_LOCKED": "verrouillé (niveau {{level}} requis)",
  "CARD_DETAIL_GATE_CHOOSE": "Choisir !",
  "CARD_DETAIL_GATE_DONE": "choisi",
  "CARD_DETAIL_CHOOSE": "Choisir",
  "CARD_DETAIL_NODE_REQUIRES": "Nécessite : {{id}}",
  "CARD_DETAIL_RESET": "Réinitialiser ({{cost}} 💎)",
  "CARD_DETAIL_RESET_NO_GEMS": "Pas assez de gemmes (150 requis)",
  "CARD_DETAIL_CAT_TOWER": "TOUR",
  "CARD_DETAIL_CAT_UNIT": "UNITÉ",
  "CARD_DETAIL_CAT_HERO": "HÉROS",
  "CARD_DETAIL_STAT_DMG": "Dégâts",
  "CARD_DETAIL_STAT_SPD": "Vitesse",
  "CARD_DETAIL_STAT_RANGE": "Portée",
  "CARD_DETAIL_STAT_CRIT": "Chance critique",
  "CARD_DETAIL_STAT_SPLASH": "Dégâts de zone",
  "CARD_DETAIL_STAT_SLOW": "Ralentissement",
  "CARD_DETAIL_STAT_CHAIN": "Enchaînement",
  "CARD_DETAIL_STAT_INCOME": "Revenu",
  "CARD_DETAIL_STAT_ARMOR": "Armure",
  "CARD_DETAIL_STAT_DODGE": "Esquive",
  "CARD_DETAIL_STAT_PASSIVE": "Passif",
  "CARD_DETAIL_STAT_COOLDOWN": "Temps de recharge",

  "LOGIN_OR": "ou",
  "LOGIN_GOOGLE": "Se connecter avec Google",

  "TUTORIAL_DECK_TITLE": "Construis ton premier deck",
  "TUTORIAL_DECK_DESC": "Choisis 8 tours, 4 unités et 1 héros pour ton deck de démarrage.",
  "TUTORIAL_DECK_CONFIRM": "Confirmer le deck & démarrer",
  "TUTORIAL_DECK_NAME": "Mon premier deck",

  "MODE_SELECT_TITLE": "Choisir le mode de jeu",
  "MODE_SELECT_SUB": "Combien de joueurs vont combattre ?",
  "MODE_1V1_TITLE": "1 contre 1",
  "MODE_1V1_DESC": "Duel classique — toi contre un adversaire",
  "MODE_2V2_TITLE": "2 contre 2",
  "MODE_2V2_DESC": "Combat en équipe avec un coéquipier",
  "MODE_3V3_TITLE": "3 contre 3",
  "MODE_3V3_DESC": "Grande bataille d'équipe — 3 vs. 3",

  "MAIN_MENU_CAMPAIGN": "📖 Campagne Solo",

  "CAMPAIGN_TITLE": "Campagne Solo",
  "CAMPAIGN_SUBTITLE": "5 missions — du débutant au champion",
  "CAMPAIGN_MISSION_N": "Mission {{n}}",
  "CAMPAIGN_OBJECTIVE": "Objectif",
  "CAMPAIGN_HINT": "Terminez une mission pour débloquer la suivante.",
  "CAMPAIGN_COMPLETE_TOAST": "Mission accomplie ! +{{xp}} XP, +{{gold}} Or",
  "CAMPAIGN_FAIL_TOAST": "Mission échouée — réessaie !",

  "CAMPAIGN_M1_TITLE": "Premiers pas",
  "CAMPAIGN_M1_DESC": "Un bot débutant t'attend. Apprends les bases !",
  "CAMPAIGN_M1_OBJ": "Détruire la base ennemie",

  "CAMPAIGN_M2_TITLE": "La Horde",
  "CAMPAIGN_M2_DESC": "L'attaquant envoie des vagues sans fin. Tiens bon !",
  "CAMPAIGN_M2_OBJ": "Vaincre 30 unités ennemies",

  "CAMPAIGN_M3_TITLE": "Ruée vers l'or",
  "CAMPAIGN_M3_DESC": "Optimise ta boucle économique contre un adversaire défensif.",
  "CAMPAIGN_M3_OBJ": "Atteindre 10 or/sec de revenus",

  "CAMPAIGN_M4_TITLE": "Déluge de créatures",
  "CAMPAIGN_M4_DESC": "Un bot en essaim te bombarde sans relâche. Survie 8 minutes !",
  "CAMPAIGN_M4_OBJ": "Survivre 8 minutes",

  "CAMPAIGN_M5_TITLE": "Le Champion",
  "CAMPAIGN_M5_DESC": "Le bot le plus intelligent — utilise les contre-éléments et s'adapte. Seuls les meilleurs peuvent le vaincre.",
  "CAMPAIGN_M5_OBJ": "Détruire la base du Champion",

  "MATCH_RESULT_PLAYER": "Toi",
  "MATCH_RESULT_OPPONENT": "Adversaire",
  "MATCH_RESULT_TOWER_DAMAGE": "Dégâts des tours",
  "MATCH_RESULT_UNITS_BREAKDOWN": "Unités envoyées",
  "CAMPAIGN_HUD_OBJECTIVE": "Objectif :",

  "CHALLENGE_MODAL_TITLE": "Défi de combat !",
  "CHALLENGE_MODAL_FROM": "{{name}} te défie !",
  "CHALLENGE_MODAL_ACCEPT": "Accepter",
  "CHALLENGE_MODAL_DECLINE": "Décliner",
  "CHALLENGE_MODAL_EXPIRES": "Expire dans {{seconds}}s",

  "MAIN_MENU_COOP": "🤝 Coop PvE",
  "COOP_MATCHMAKING_TITLE": "Coop PvE",
  "COOP_MATCHMAKING_SEARCHING": "Recherche partenaire...",
  "COOP_MATCHMAKING_FOUND": "Partenaire trouvé !",
  "COOP_MATCHMAKING_PARTNER": "Partenaire : {{name}}",
  "COOP_MATCHMAKING_STARTING": "Démarrage de la défense co-op...",
  "COOP_MATCHMAKING_FALLBACK": "Aucun partenaire trouvé",
  "COOP_MATCHMAKING_FALLBACK_DESC": "Tu combats seul contre les bots.",
  "COOP_MATCHMAKING_CANCEL": "Annuler",
  "COOP_MATCHMAKING_OFFLINE": "Serveur indisponible",
  "COOP_MATCHMAKING_OFFLINE_DESC": "Coop solo : défense seul contre les bots.",
  "HUD_COOP_PARTNER_HP": "Partenaire ♥",
  "HUD_COOP_PARTNER_DEFEATED": "Partenaire vaincu !",

  "SEASON_DAYS_LEFT": "{{days}} jours restants",
  "SEASON_LEVEL_LABEL": "Niveau {{level}} / {{max}}",
  "SEASON_PREMIUM_DESC": "Déverrouillez la piste premium — gemmes exclusives, packs et un titre pour chaque niveau.",
  "SEASON_BUY_PASS": "Acheter le Passe Saison",
  "SEASON_PREMIUM_ACTIVE": "Piste premium déverrouillée — toutes les récompenses premium disponibles !",
  "SEASON_PASS_OWNED": "Possédé ✓",
  "SEASON_TRACK_FREE": "Gratuit",
  "SEASON_TRACK_PREMIUM": "Premium",
  "SEASON_CLAIM": "Récupérer",
  "SEASON_CLAIMED": "Récupéré ✓",
  "SEASON_LOCKED": "Verrouillé",
  "SEASON_PREMIUM_ONLY": "Premium uniquement",
  "SEASON_CLAIMED_COUNT": "{{count}} / {{total}} récompenses récupérées",
  "SEASON_XP_LABEL": "XP Saison",

  "FRIENDS_TITLE": "Amis",
  "FRIENDS_TAB_FRIENDS": "Amis",
  "FRIENDS_ADD_PLACEHOLDER": "Entrez le code joueur (#XXXXXX)",
  "FRIENDS_SEND_REQUEST": "Envoyer une demande",
  "FRIENDS_REMOVE": "Supprimer",
  "FRIENDS_CHALLENGE_SENT": "Défi envoyé ! 60 secondes pour accepter.",

  "REPLAY_TITLE": "Historique des matchs",
  "REPLAY_EMPTY": "Aucun match joue pour l'instant.",
  "REPLAY_OUTCOME_WIN": "Victoire",
  "REPLAY_OUTCOME_LOSS": "Defaite",
  "REPLAY_OUTCOME_DRAW": "Match nul",
  "REPLAY_VIEW_BUTTON": "Replay",
  "REPLAY_NO_DATA": "Aucune donnee de replay disponible.",
  "REPLAY_TIMELINE_TITLE": "Chronologie du match",
  "REPLAY_HP_CHART_LABEL": "Graphique HP",
  "REPLAY_GOLD_CHART_LABEL": "Graphique Or",
  "REPLAY_EVENTS_LABEL": "Evenements cles",
  "REPLAY_CLOSE": "Fermer",
  "REPLAY_PLAY": "Lecture",
  "REPLAY_PAUSE": "Pause",
  "REPLAY_MY_HP":      "Mes HP",
  "REPLAY_OPP_HP":     "HP adversaire",
  "REPLAY_HP_CHART":   "Graphique HP",
  "REPLAY_KEY_EVENTS": "Événements clés",
  "REPLAY_VIEW_BTN":   "Replay",

  "PROFILE_TITLE": "Mon Profil",
  "PROFILE_STATS": "Statistiques",
  "PROFILE_AVATAR": "Choisir un avatar",
  "PROFILE_BIO": "Bio",
  "PROFILE_SAVE": "Sauvegarder",
  "PROFILE_SAVED": "Sauvegarde !",
  "PROFILE_WINRATE": "Taux de victoire",

  "SEASON_ENDS_IN": "La saison se termine dans {{days}} jours",
  "SEASON_ENDED": "Saison terminee ! Reclamez vos recompenses.",
  "SEASON_CLAIM_REWARDS": "Reclamer les recompenses",
  "SEASON_REWARDS_CLAIMED": "Recompenses recues !",
  "SEASON_NEXT": "Prochaine saison",
  "SEASON_TITLE_EARNED": "Titre obtenu",

  "SPECTATOR_TITLE":   "Matchs en direct",
  "SPECTATOR_LIVE":    "LIVE",
  "SPECTATOR_EMPTY":   "Aucun match actif en ce moment.",
  "SPECTATOR_WATCH":   "Regarder",
  "SPECTATOR_LEAVE":   "Quitter",
  "SPECTATOR_PLAYER1": "Joueur 1",
  "SPECTATOR_PLAYER2": "Joueur 2",
  "SPECTATOR_BACK":    "Retour",

  "TOURNAMENT_TITLE":          "Tournoi",
  "TOURNAMENT_JOIN":           "Rejoindre",
  "TOURNAMENT_JOINED":         "Inscrit avec succes !",
  "TOURNAMENT_FULL":           "Tournoi complet !",
  "TOURNAMENT_BRACKET":        "Tableau",
  "TOURNAMENT_MY":             "Mon tournoi",
  "TOURNAMENT_EMPTY":          "Aucun tournoi ouvert. Revenez plus tard !",
  "TOURNAMENT_STATUS_OPEN":    "Ouvert",
  "TOURNAMENT_STATUS_RUNNING": "En cours",
  "TOURNAMENT_CHAMPION":       "Champion",

  "CHAT_PLACEHOLDER":     "Message...",
  "CHAT_SEND":            "Envoyer",
  "CHAT_TOGGLE":          "Chat",
  "CHAT_NO_MESSAGES":     "Aucun message pour l'instant",
  "CHAT_QUICK_PHRASE_GG": "GG — envoyer une phrase rapide",
  "CHAT_RATE_LIMIT":      "Veuillez patienter avant d'envoyer à nouveau.",

  "STREAK_TITLE":      "Récompense de connexion",
  "STREAK_BROKEN":     "Série perdue — mais redémarrée aujourd'hui !",
  "STREAK_DAY":        "Jour {{day}} — Récompense de connexion",
  "STREAK_CLAIM":      "Collecter !",
  "STREAK_JACKPOT":    "Série de 7 jours accomplie !",
  "STREAK_DAYS_LABEL": "Série : {{day}} jour{{plural}}",

  "CLAN_TITLE":       "Clans",
  "CLAN_MY":          "Mon Clan",
  "CLAN_SEARCH":      "Chercher",
  "CLAN_CREATE":      "Créer",
  "CLAN_LEADERBOARD": "Classement",
  "CLAN_JOIN":        "Rejoindre",
  "CLAN_LEAVE":       "Quitter le clan",
  "CLAN_NAME":        "Nom du clan",
  "CLAN_TAG":         "Tag",
  "CLAN_DESC":        "Description",
  "CLAN_FULL":        "Clan complet (max 50 membres)",
  "CLAN_EMPTY":       "Aucun clan trouvé",
  "CLAN_CREATED":     "Clan créé",
  "CLAN_JOINED":      "Rejoint",
  "CLAN_LEFT":        "Clan quitté",
  "CLAN_OWNER":       "Chef",
  "CLAN_MEMBER":      "Membre",
  "CLAN_OFFICER":     "Officier",
  "CLAN_NOT_IN_CLAN":        "Vous n'êtes dans aucun clan",
  "CLAN_TOTAL_ELO":          "ELO total",
  "CLAN_SEARCH_PLACEHOLDER": "Rechercher nom de clan / TAG…",
  "CLAN_TAG_HINT":           "3–5 majuscules ou chiffres (ex. FIRE)",

  "LEADERBOARD_TAB_GLOBAL":  "Mondial",
  "LEADERBOARD_TAB_FRIENDS": "Amis",
  "LEADERBOARD_RANK":        "#",
  "LEADERBOARD_PLAYER":      "Joueur",
  "LEADERBOARD_RECORD":      "V-D",
  "LEADERBOARD_POINTS":      "ELO",
  "LEADERBOARD_LOGIN_PROMPT": "Connectez-vous pour voir le classement",
  "LEADERBOARD_YOU":         "Vous",

  "AUTH_LOGIN_TITLE":                "Se connecter",
  "AUTH_REGISTER_TITLE":             "S'inscrire",
  "AUTH_FORGOT_TITLE":               "Réinitialiser le mot de passe",
  "AUTH_EMAIL":                      "E-Mail",
  "AUTH_USERNAME":                   "Nom d'utilisateur",
  "AUTH_PASSWORD":                   "Mot de passe",
  "AUTH_CONFIRM_PASSWORD":           "Confirmer le mot de passe",
  "AUTH_LOGIN_BTN":                  "Se connecter",
  "AUTH_REGISTER_BTN":               "S'inscrire",
  "AUTH_FORGOT_BTN":                 "Envoyer le lien de réinitialisation",
  "AUTH_GUEST_BTN":                  "Jouer en tant qu'invité",
  "AUTH_SWITCH_TO_REGISTER":         "Pas encore de compte ? S'inscrire",
  "AUTH_SWITCH_TO_LOGIN":            "Déjà un compte ? Se connecter",
  "AUTH_SWITCH_TO_FORGOT":           "Mot de passe oublié ?",
  "AUTH_SWITCH_TO_LOGIN_FROM_FORGOT": "Retour à la connexion",
  "AUTH_FORGOT_SUCCESS":             "Si cet e-mail est enregistré, un lien de réinitialisation a été envoyé.",
  "AUTH_MAIN_MENU_GREETING":         "Bonjour, {{username}}",
  "AUTH_LOGOUT_BTN":                 "Se déconnecter",
  "AUTH_LOGIN_REGISTER_BTN":         "Connexion / Inscription",
  "AUTH_ERROR_PASSWORDS_MISMATCH":   "Les mots de passe ne correspondent pas",
  "AUTH_ERROR_USERNAME_TOO_SHORT":   "Le nom d'utilisateur doit comporter au moins 3 caractères",
  "AUTH_ERROR_PASSWORD_TOO_SHORT":   "Le mot de passe doit comporter au moins 6 caractères"
}
